/* eslint-disable */
import createIcon from '../createIcon';

const IconCheckCircleFilled = createIcon({
  name: 'icon-check-circle-filled',
  content: '<path d="M449.856 706.56l-45.44-45.056.128-.064L268.16 526.016l45.12-45.44L449.6 616.064 720.192 343.68l45.376 45.056-315.712 317.888zM510.528 64A448 448 0 10960 510.528 448 448 0 00510.528 64z" fill="currentColor"/>',
  width: 1024,
  height: 1024
});
export default IconCheckCircleFilled;
